// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"9c10c06b","428":"84625f26","488":"e0eeadc6","601":"5cef27ed","839":"80698ff7"}[chunkId] + ".chunk.js";
};